import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import draftLocked from "../../../public/BP_resources/images/icon//locked.svg";
import unlockedGrey from "../../../public/BP_resources/images/icon/unlocked-grey.svg";
import lockedGrey from "../../../public/BP_resources/images/icon/addcheck.svg";
import locked from "../../../public/BP_resources/images/icon/addcheck.svg";
import unlocked from "../../../public/BP_resources/images/icon/unlocked.svg";
import CheckAlreadyRequestedModal from "../CostDashboard/CheckAlreadyRequested";
import { currencyFormat, formatCalendarDate } from "../../Utils/helper";
import SettlementNoCheckModal from "../Modals/SettlementNoCheckModal";
import SettlementCheckRequest from "../Modals/SettlementCheckRequest";
import SettlementErrorModal from "../Modals/SettlementErrorModal";
import AddCostReimburstmentPopUp from "../Modals/AddCostReimburstmentPopUp";
import GenericSettlementAddPopup from "../Modals/GenericSettlementAddPopup";

import updateLockSettleAmount from "./common/updateLockSettleAmount";
import updateLockSettleValue from "./common/updateLockSettleValue";
import AllLockSettle from "./common/AllLockSettle";
import ChequeUpload from "./ChequeUpload";
import CopyValueSettlement from "./common/CopyValueSettlement";
import SectionActionBar from "./SectionActionBar";
import updateRightColumnValue from "./common/updateRightColumnValue";
import SettlementEmptyMessage from "./SettlementEmptyMessage";
import SettlementCheckDetails from "./common/SettlementCheckDetails";
import SettlementCurrencyInput, {
  getSettlementCurrencyInputSum,
} from "./common/SettlementCurrencyInput";
import { hasNonZeroSettlementAmount, hasSettlementCheck } from "./common/settlementCheckGuards";

const SettlementCosts = ({
  costsObj,
  clientProceed,
  costsReimbursementsObj,
  settlementObjProps,
}) => {
  // const [, setIsHovered] = useState({ id: -1, value: false });
  const [showSettlementPopup, setShowSettlementPopup] = useState(false);
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [currentCheck, setCurrentCheck] = useState(null);
  const caseSummary = useSelector((state) => state?.caseData?.summary);
  const lockAllCosts = (bType, boolVal) => {
    AllLockSettle("cost_reimbursement", bType, boolVal);
    if (bType === "draft1") {
      setCostsReimbursementsLocks((prevStates) =>
        prevStates.map((row) => ({
          ...row,
          isDraftLocked: hasSettlementCheck(row) ? row.isDraftLocked : boolVal === "true",
        }))
      );
    } else {
      setCostsReimbursementsLocks((prevStates) =>
        prevStates.map((row) => ({
          ...row,
          isFinalLocked: row.checkID ? row.isFinalLocked : boolVal === "true",
        }))
      );
    }
    // AllLockSettle("cost_settle",bType,boolVal);
    // if(bType === "draft1"){
    //     const obj = {
    //         ...itemizedCost,
    //         chv_settle : {
    //             ...itemizedCost.chv_settle,
    //             draft1_checked: boolVal === "true"
    //         }
    //     }
    //     setItemizedCost(obj);
    // }
    // else{
    //     const obj = {
    //         ...itemizedCost,
    //         chv_settle : {
    //             ...itemizedCost.chv_settle,
    //             final_checked: itemizedCost.chv_settle.checkID ? itemizedCost.chv_settle.draft1_checked : boolVal === "true"
    //         }
    //     }
    //     setItemizedCost(obj);
    // }
  };
  const page_id_click_record = useSelector(
    (state) => state.page_id_click_record.page_id_click_record
  );
  const [errorMsg, _setMsgError] = useState("");
  const [showNoCheckModal, setNoCheckModal] = useState(false);
  const handleNoCheckClose = () => setNoCheckModal(false);
  const handleNoCheckShow = () => setNoCheckModal(true);
  const [checkAlreadyRequested, setCheckAlreadyRequested] = useState(false);
  const handleCheckAlreadyRequestedClose = () => setCheckAlreadyRequested(false);
  const handleCheckedRowClick = (event) => {
    event?.stopPropagation();
    setCheckAlreadyRequested(true);
  };

  const [showCheckRequestModal, setCheckRequestModal] = useState(false);
  const handleCheckRequestClose = () => setCheckRequestModal(false);

  const handleDraftLockChange = (id, sectionName, e) => {
    e.stopPropagation();
    if (sectionName === "cost_settle") {
      updateLockSettleValue(id, "cost_settle", "draft1");
      const obj = {
        ...itemizedCost,
        chv_settle: {
          ...itemizedCost.chv_settle,
          draft1_checked: !itemizedCost.chv_settle.draft1_checked,
        },
      };
      setItemizedCost(obj);
    } else if (sectionName === "cost_reimbursement") {
      const lock = costsReimbursementsLocks.find((row) => row.id === id);
      if (hasSettlementCheck(lock)) {
        handleCheckedRowClick(e);
        return;
      }
      updateLockSettleValue(id, "cost_reimbursement", "draft1");
      setCostsReimbursementsLocks((prevStates) =>
        prevStates.map((row) =>
          row.id === id ? { ...row, isDraftLocked: !row.isDraftLocked } : row
        )
      );
    }
  };
  const handleFinalLockChange = (id, sectionName, e) => {
    e.stopPropagation();
    if (sectionName === "cost_settle") {
      updateLockSettleValue(id, "cost_settle", "final");
      const obj = {
        ...itemizedCost,
        chv_settle: {
          ...itemizedCost.chv_settle,
          final_checked: !itemizedCost.chv_settle.final_checked,
        },
      };
      setItemizedCost(obj);
    } else if (sectionName === "cost_reimbursement") {
      const lock = costsReimbursementsLocks.find((row) => row.id === id);
      if (hasSettlementCheck(lock)) {
        handleCheckedRowClick(e);
        return;
      }
      updateLockSettleValue(id, "cost_reimbursement", "final");
      setCostsReimbursementsLocks((prevStates) =>
        prevStates.map((row) =>
          row.id === id ? { ...row, isFinalLocked: !row.isFinalLocked } : row
        )
      );
    }
  };
  const {
    itemizedCost,
    setItemizedCost,
    costFinalAmount,

    showErrorModal,
    handleErrorClose,
    handleErrorShow: _handleErrorShow,
    updateCostsState,
  } = costsObj;
  const [action, setAction] = useState("");
  const {
    costsReimbursementsLocks,
    setCostsReimbursementsLocks,
    costsReimbursements,
    costReimbursementsFinalAmount,
    costReimbursementsLockValues,
    setCostReimbursementsLockValues,
    showCostModal,
    handleCostClose,
    handleCostShow,
    updateCostsReimbursementsState,
  } = costsReimbursementsObj;
  const [currentCostReimbursement, setCurrentCostReimbursement] = useState(costsReimbursements[0]);

  const [colSpanValue, setColSpanValue] = useState(
    document.documentElement.clientWidth < 2100 ? 6 : 9
  );
  useEffect(() => {
    const handleResize = () => {
      setColSpanValue(document.documentElement.clientWidth < 2100 ? 6 : 9);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <div className="">
        <SectionActionBar sectionName={"Costs"} />
        <div className="table--no-card rounded-0 border-0 w-100">
          <table className="table table-borderless table-striped table-earning settlement-table">
            <thead>
              <tr id="settle-tb-header" className="settle-t-3 cursor-default">
                <th />
                <th className="td-autosize text-start first-col" />
                <th className="text-end td-autosize med-bill-width">Fixed</th>
                <th className="text-end td-autosize med-bill-width hide-table-data2">
                  <div className="d-flex justify-content-end align-items-center">
                    <span className="text-p-50">{itemizedCost.open_count}</span>
                    <span>&nbsp;Open</span>
                  </div>
                </th>
                <th className="text-end td-autosize med-bill-width hide-table-data2">
                  <div className="d-flex justify-content-end align-items-center">
                    <span className="text-p-50">{itemizedCost.requested_count}</span>
                    <span>&nbsp;Requests</span>
                  </div>
                </th>
                <th className="text-end td-autosize med-bill-width">
                  <div className="d-flex justify-content-end align-items-center">
                    <span className="text-p-50">{itemizedCost.paid_count}</span>
                    <span>&nbsp;Paid</span>
                  </div>
                </th>
                <th className="text-end td-autosize med-bill-width hide-table-data2" />
                <th className="text-end td-autosize med-bill-width">Reimbursed</th>
                {/* <th className="text-end td-autosize med-bill-width">Total</th> */}
                <th className="" />
                <th
                  className={`text-end td-autosize ${costsReimbursementsLocks?.some((lock) => !lock.isDraftLocked && !hasSettlementCheck(lock)) ? "cursor-pointer" : ""}`}
                  // style={{color:"var(--primary-25) !important"}}
                  onClick={(e) => {
                    e.stopPropagation();
                    const draftLockCheck = costsReimbursementsLocks?.some(
                      (lock) => !lock.isDraftLocked && !hasSettlementCheck(lock)
                    );
                    if (draftLockCheck) {
                      costsReimbursementsLocks?.forEach((costReimburse, index) => {
                        if (!costReimburse.isDraftLocked && !hasSettlementCheck(costReimburse)) {
                          updateRightColumnValue(
                            costReimburse.isDraftLocked,
                            costReimburse.isFinalLocked,
                            setCostsReimbursementsLocks,
                            "reimburse-draft",
                            costReimburse.id,
                            costReimbursementsLockValues,
                            setCostReimbursementsLockValues,
                            "cost_reimbursement",
                            "draft1",
                            costsReimbursements[index].amount
                          );
                        }
                      });
                      updateCostsReimbursementsState();
                      clientProceed.updateClientProceedsState();
                    }
                  }}
                >
                  <span className="d-flex align-items-center justify-content-end position-relative center-val-div">
                    {costsReimbursementsLocks?.some(
                      (lock) => !lock.isDraftLocked && !hasSettlementCheck(lock)
                    ) && <CopyValueSettlement />}
                    Total
                  </span>
                </th>
                <th
                  className="s-draft text-end"
                  style={{ color: "var(--primary-25) !important" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    const finalLockCheck = costsReimbursementsLocks?.some(
                      (lock) =>
                        lock.isDraftLocked && !lock.isFinalLocked && !hasSettlementCheck(lock)
                    );
                    if (finalLockCheck) {
                      costsReimbursementsLocks?.forEach((costReimburse) => {
                        if (
                          costReimburse.isDraftLocked &&
                          !costReimburse.isFinalLocked &&
                          !hasSettlementCheck(costReimburse)
                        ) {
                          updateRightColumnValue(
                            costReimburse.isDraftLocked,
                            costReimburse.isFinalLocked,
                            setCostsReimbursementsLocks,
                            "reimburse-final",
                            costReimburse.id,
                            costReimbursementsLockValues,
                            setCostReimbursementsLockValues,
                            "cost_reimbursement",
                            "final",
                            costReimburse.isDraftAmount
                          );
                        }
                      });
                      clientProceed.updateClientProceedsState();
                    }
                  }}
                >
                  <div className="central-header-div d-flex justify-content-between align-items-center height-25">
                    <div className="d-flex align-items-center position-relative">
                      <img
                        className="invisible ic ic-19"
                        id="lock-image"
                        src={unlocked}
                        alt="lock-icon"
                        style={{ cursor: "pointer" }}
                      />
                      <img
                        id="lock-image"
                        className="ic ic-19 lock-icon"
                        src={unlocked}
                        alt="lock-icon"
                        onClick={(e) => {
                          e.stopPropagation();
                          lockAllCosts("draft1", "false");
                        }}
                        style={{ cursor: "pointer" }}
                      />
                      <img
                        id="unlock-image"
                        className="ic ic-19 lock-icon"
                        alt="lock-icon"
                        onClick={(e) => {
                          e.stopPropagation();
                          lockAllCosts("draft1", "true");
                        }}
                        src={draftLocked}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                    <span
                      className="d-flex align-items-center justify-content-end position-relative center-val-div draft-central-div"
                      style={{ paddingRight: "2px" }}
                    >
                      {costsReimbursementsLocks?.some(
                        (lock) =>
                          lock.isDraftLocked && !lock.isFinalLocked && !hasSettlementCheck(lock)
                      ) && <CopyValueSettlement />}
                      <span className="position-absolute right-0">Draft</span>
                    </span>
                  </div>
                </th>
                <th className="s-final text-end" style={{ color: "var(--primary-25) !important" }}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                      <img
                        className="invisible ic ic-19"
                        id="lock-image"
                        src={unlocked}
                        alt="lock-icon"
                        style={{ cursor: "pointer" }}
                      />
                      <img
                        id="lock-image"
                        className="ic ic-19"
                        src={unlocked}
                        alt="lock-icon"
                        onClick={(e) => {
                          e.stopPropagation();
                          lockAllCosts("final", "false");
                        }}
                        style={{ cursor: "pointer" }}
                      />
                      <img
                        id="unlock-image"
                        className="ic ic-19"
                        alt="lock-icon"
                        src={locked}
                        onClick={(e) => {
                          e.stopPropagation();
                          lockAllCosts("final", "true");
                        }}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                    <span style={{ paddingRight: "2px" }}>Final</span>
                  </div>
                </th>
                <th className="s-verify" />
                <th
                  className="td-autosize check-request--btn-settle text-center"
                  style={{ color: "var(--primary-25) !important" }}
                >
                  Check
                </th>
              </tr>
            </thead>

            <tbody id="body-table">
              <>
                {Object.keys(itemizedCost.chv_settle).length === 0 &&
                  costsReimbursements?.length === 0 && (
                    <tr id="cost-settle-row cursor-default" className="padding-tr-0">
                      <td className="text=center cursor-pointer" colSpan={colSpanValue + 5}>
                        <SettlementEmptyMessage
                          name="FIRM COST REIMBURSEMENTS"
                          onClick={(e) => {
                            e.stopPropagation();
                            setShowSettlementPopup(true);
                          }}
                        />
                      </td>
                    </tr>
                  )}

                {Object.keys(itemizedCost.chv_settle).length > 0 && (
                  <>
                    <tr id="cost-settle-row cursor-default">
                      <td className="" />
                      <td className="text-start td-autosize text-capitalize first-col">
                        Total Costs
                      </td>
                      <td
                        className="text-end med-bill-width td-autosize monospace-font dollar-amount-value"
                        data-value={itemizedCost?.total_amount}
                      >
                        {currencyFormat(itemizedCost?.total_amount)}
                      </td>
                      <td
                        className="td-autosize monospace-font text-end dollar-amount-value med-bill-width hide-table-data2"
                        data-value={itemizedCost.open || "0.00"}
                      >
                        {currencyFormat(itemizedCost.open)}
                      </td>
                      <td
                        className="td-autosize monospace-font text-end dollar-amount-value med-bill-width hide-table-data2"
                        data-value={itemizedCost.requested || "0.00"}
                      >
                        {currencyFormat(itemizedCost.requested)}
                      </td>
                      <td
                        className="td-autosize monospace-font text-end med-bill-width dollar-amount-value"
                        data-value={itemizedCost.paid || "0.00"}
                      >
                        {currencyFormat(itemizedCost.paid)}
                      </td>
                      <td className="td-autosize text-end med-bill-width hide-table-data2" />
                      <td
                        className="td-autosize monospace-font text-end dollar-amount-value med-bill-width"
                        data-value={parseFloat(
                          costsReimbursements?.reduce((acc, costReimburse) => {
                            return costReimburse?.checkID?.check_sent
                              ? acc + parseFloat(costReimburse.amount)
                              : acc;
                          }, 0.0)
                        )}
                      >
                        {currencyFormat(
                          costsReimbursements?.reduce((acc, costReimburse) => {
                            return costReimburse?.checkID?.check_sent
                              ? acc + parseFloat(costReimburse.amount)
                              : acc;
                          }, 0.0)
                        )}
                      </td>
                      {/* <td className="td-autosize monospace-font text-end dollar-amount-value med-bill-width" data-value={parseFloat(costFinalAmount)}>{currencyFormat(costFinalAmount)}</td> */}
                      <td className="" />
                      <td
                        className="td-autosize monospace-font text-end dollar-amount-value"
                        data-value={parseFloat(costFinalAmount)}
                      >
                        {currencyFormat(costFinalAmount)}
                      </td>
                      <td className="s-draft text-end monospace-font">
                        <span
                          style={{ paddingRight: "2px" }}
                          data-value={parseFloat(costFinalAmount)}
                        >
                          {currencyFormat(costFinalAmount)}
                        </span>
                      </td>
                      <td className="s-final text-end monospace-font">
                        <span
                          style={{ paddingRight: "2px" }}
                          data-value={parseFloat(costFinalAmount)}
                        >
                          {currencyFormat(costFinalAmount)}
                        </span>
                      </td>
                      <td className="s-verify" />
                      <td className="td-autosize " />
                    </tr>

                    {costsReimbursements?.map((costReimburse, index) => (
                      <tr className="cursor-default">
                        <td>{index + 1}</td>
                        <td
                          className="text-start"
                          colSpan={colSpanValue - 1}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div
                            className="d-flex"
                            style={{ width: "fit-content" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setAction("EDIT");
                              setCurrentCheck(costReimburse);
                              setCurrentCostReimbursement(costReimburse);
                              handleCostShow();
                            }}
                          >
                            <span className="td-autosize first-col">
                              {costReimburse?.date_due && (
                                <span className="m-r-5">
                                  {formatCalendarDate(costReimburse?.date_due)}
                                </span>
                              )}
                              <span>Firm Reimbursement Check for</span>&nbsp;
                              <span
                                className="monospace-font dollar-amount-value"
                                data-value={costReimburse?.amount || 0.0}
                              >
                                {currencyFormat(costReimburse?.amount)}
                              </span>
                            </span>
                          </div>
                        </td>
                        <td
                          className={`monospace-font td-autosize dollar-amount-value text-end ${!costsReimbursementsLocks[index].isDraftLocked && !hasSettlementCheck(costsReimbursementsLocks[index]) ? "cursor-pointer" : ""}`}
                          data-value={costReimburse?.amount}
                        >
                          <span
                            className={`d-flex align-items-center ${!costsReimbursementsLocks[index].isDraftLocked && !hasSettlementCheck(costsReimbursementsLocks[index]) ? "justify-content-between cursor-pointer" : "justify-content-end"} align-items-center position-relative center-val-div`}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (hasSettlementCheck(costsReimbursementsLocks[index])) {
                                handleCheckedRowClick(e);
                                return;
                              }
                              updateRightColumnValue(
                                costsReimbursementsLocks[index].isDraftLocked,
                                costsReimbursementsLocks[index].isFinalLocked,
                                setCostsReimbursementsLocks,
                                "reimburse-draft",
                                costReimburse?.id,
                                costReimbursementsLockValues,
                                setCostReimbursementsLockValues,
                                "cost_reimbursement",
                                "draft1",
                                costReimburse?.amount
                              );
                              updateCostsReimbursementsState();
                              clientProceed.updateClientProceedsState();
                            }}
                          >
                            {!costsReimbursementsLocks[index].isDraftLocked &&
                              !hasSettlementCheck(costsReimbursementsLocks[index]) && (
                                <CopyValueSettlement />
                              )}
                            {currencyFormat(costReimburse?.amount)}
                          </span>
                        </td>
                        <td
                          className="s-draft text-end"
                          onClick={(e) => {
                            e.stopPropagation();
                            if (hasSettlementCheck(costsReimbursementsLocks[index])) {
                              handleCheckedRowClick(e);
                              return;
                            }
                            updateRightColumnValue(
                              costsReimbursementsLocks[index].isDraftLocked,
                              costsReimbursementsLocks[index].isFinalLocked,
                              setCostsReimbursementsLocks,
                              "reimburse-final",
                              costReimburse?.id,
                              costReimbursementsLockValues,
                              setCostReimbursementsLockValues,
                              "cost_reimbursement",
                              "final",
                              costsReimbursementsLocks[index].isDraftAmount
                            );
                            updateCostsReimbursementsState();
                            clientProceed.updateClientProceedsState();
                          }}
                        >
                          <div
                            className={
                              "monospace-font d-flex justify-content-between align-items-center height-25 position-relative center-val-div"
                            }
                          >
                            <span>
                              {!hasSettlementCheck(costsReimbursementsLocks[index]) && (
                                <img
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleDraftLockChange(
                                      costReimburse?.id,
                                      "cost_reimbursement",
                                      e
                                    );
                                  }}
                                  id="lock-image"
                                  className="ic ic-15"
                                  src={
                                    costsReimbursementsLocks[index].isDraftLocked
                                      ? draftLocked
                                      : unlocked
                                  }
                                  alt="lock-icon"
                                  style={{ cursor: "pointer" }}
                                />
                              )}
                            </span>
                            <SettlementCurrencyInput
                              id="lock-input"
                              className={`${costsReimbursementsLocks[index].isDraftLocked && !costsReimbursementsLocks[index].isFinalLocked ? "cursor-pointer" : ""} monospace-font reimburse-draft-${costReimburse?.id} text-end reimburse-draft dollar-amount-value ${costsReimbursementsLocks[index].isDraftLocked ? "locked-input" : "unlock-input"}`}
                              value={costReimburse?.draft1}
                              readOnly={
                                costsReimbursementsLocks[index].isDraftLocked ||
                                hasSettlementCheck(costsReimbursementsLocks[index])
                              }
                              onClick={(e) => {
                                if (hasSettlementCheck(costsReimbursementsLocks[index])) {
                                  handleCheckedRowClick(e);
                                  return;
                                }
                                e.target.focus();
                              }}
                              onLocalChange={({ dataValue }) => {
                                if (hasSettlementCheck(costsReimbursementsLocks[index])) return;
                                setCostsReimbursementsLocks((prevStates) =>
                                  prevStates.map((row) =>
                                    row.id === costReimburse?.id
                                      ? { ...row, isDraftAmount: dataValue }
                                      : row
                                  )
                                );
                                const sum = getSettlementCurrencyInputSum("reimburse-draft");
                                setCostReimbursementsLockValues((prevValues) => [
                                  sum,
                                  prevValues[1],
                                ]);
                              }}
                              onDebouncedCommit={async ({ submitValue }) => {
                                if (hasSettlementCheck(costsReimbursementsLocks[index])) return;
                                await updateLockSettleAmount(
                                  costReimburse?.id,
                                  "cost_reimbursement",
                                  "draft1",
                                  submitValue
                                );
                                updateCostsReimbursementsState();
                                clientProceed.updateClientProceedsState();
                              }}
                              onMouseEnter={(e) => {
                                if (
                                  costsReimbursementsLocks[index].isDraftLocked &&
                                  !costsReimbursementsLocks[index].isFinalLocked
                                ) {
                                  const container = e.currentTarget.closest(".center-val-div");
                                  const lockImg = container?.querySelector("#lock-image");
                                  const copyElement = container?.querySelector(
                                    ".copy-centered-draft, .copy-centered-final, .copy-centered"
                                  );
                                  if (lockImg) {
                                    lockImg.style.opacity = 0;
                                    lockImg.style.zIndex = 0;
                                  }
                                  if (copyElement) {
                                    copyElement.style.opacity = 1;
                                    copyElement.style.zIndex = 1;
                                    copyElement.style.cursor = "pointer";
                                    copyElement.style.display = "flex";
                                  }
                                }
                              }}
                              onMouseLeave={(e) => {
                                if (
                                  costsReimbursementsLocks[index].isDraftLocked &&
                                  !costsReimbursementsLocks[index].isFinalLocked
                                ) {
                                  const container = e.currentTarget.closest(".center-val-div");
                                  const lockImg = container?.querySelector("#lock-image");
                                  const copyElement = container?.querySelector(
                                    ".copy-centered-draft, .copy-centered-final, .copy-centered"
                                  );
                                  if (lockImg) {
                                    lockImg.style.opacity = 1;
                                    lockImg.style.zIndex = 4;
                                  }
                                  if (copyElement) {
                                    copyElement.style.opacity = 0;
                                    copyElement.style.zIndex = 0;
                                    copyElement.style.cursor = "initial";
                                    copyElement.style.display = "none";
                                  }
                                }
                              }}
                              style={{ zIndex: 2 }}
                            />
                            {costsReimbursementsLocks[index].isDraftLocked &&
                              !costsReimbursementsLocks[index].isFinalLocked &&
                              !hasSettlementCheck(costsReimbursementsLocks[index]) && (
                                <CopyValueSettlement draft={true} />
                              )}
                          </div>
                        </td>
                        <td className="s-final">
                          <div
                            // onMouseEnter={() =>
                            //   setIsHovered({
                            //     id: costReimburse?.id,
                            //     value: true,
                            //   })
                            // }
                            // onMouseLeave={() =>
                            //   setIsHovered({
                            //     id: costReimburse?.id,
                            //     value: false,
                            //   })
                            // }
                            className="monospace-font d-flex justify-content-between align-items-center height-25 position-relative center-val-div"
                          >
                            <span>
                              {!hasSettlementCheck(costsReimbursementsLocks[index]) && (
                                <img
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleFinalLockChange(
                                      costReimburse?.id,
                                      "cost_reimbursement",
                                      e
                                    );
                                  }}
                                  id="lock-image"
                                  className={`ic ic-15 ${costsReimbursementsLocks[index].checkID?.check_sent ? "invisible" : ""}`}
                                  src={
                                    costsReimbursementsLocks[index].isFinalLocked
                                      ? costsReimbursementsLocks[index].checkID?.check_sent
                                        ? lockedGrey
                                        : draftLocked
                                      : costsReimbursementsLocks[index].checkID?.check_sent
                                        ? unlockedGrey
                                        : unlocked
                                  }
                                  alt="lock-icon"
                                  style={{ cursor: "pointer" }}
                                  // onMouseEnter={() =>
                                  //   setIsHovered({
                                  //     id: costReimburse?.id,
                                  //     value: false,
                                  //   })
                                  // }
                                  // onMouseLeave={() =>
                                  //   setIsHovered({
                                  //     id: costReimburse?.id,
                                  //     value: true,
                                  //   })
                                  // }
                                />
                              )}
                            </span>
                            <SettlementCurrencyInput
                              id="lock-input"
                              className={`${!costsReimbursementsLocks[index].checkID && costsReimbursementsLocks[index].isFinalLocked ? "cursor-pointer" : ""} monospace-font reimburse-final-${costReimburse?.id} text-end reimburse-final dollar-amount-value ${costsReimbursementsLocks[index].isFinalLocked ? "locked-input" : "unlock-input"}`}
                              value={costReimburse?.final}
                              readOnly={
                                costsReimbursementsLocks[index].isFinalLocked ||
                                hasSettlementCheck(costsReimbursementsLocks[index])
                              }
                              onClick={async (e) => {
                                e.stopPropagation();
                                if (hasSettlementCheck(costsReimbursementsLocks[index])) {
                                  handleCheckedRowClick(e);
                                  return;
                                }
                                e.target.focus();
                              }}
                              onLocalChange={({ dataValue }) => {
                                if (hasSettlementCheck(costsReimbursementsLocks[index])) return;
                                setCostsReimbursementsLocks((prevStates) =>
                                  prevStates.map((row) =>
                                    row.id === costReimburse?.id
                                      ? { ...row, isFinalAmount: dataValue }
                                      : row
                                  )
                                );
                                const sum = getSettlementCurrencyInputSum("reimburse-final");
                                setCostReimbursementsLockValues((prevValues) => [
                                  prevValues[0],
                                  sum,
                                ]);
                              }}
                              onDebouncedCommit={async ({ submitValue }) => {
                                if (hasSettlementCheck(costsReimbursementsLocks[index])) return;
                                await updateLockSettleAmount(
                                  costReimburse?.id,
                                  "cost_reimbursement",
                                  "final",
                                  submitValue
                                );
                                updateCostsReimbursementsState();
                                clientProceed.updateClientProceedsState();
                              }}
                            />
                            {!costsReimbursementsLocks[index].checkID &&
                              costsReimbursementsLocks[index].isFinalLocked && (
                                <CopyValueSettlement draft={true} final={true} />
                              )}
                          </div>
                        </td>
                        <td className="s-verify" onClick={(e) => e.stopPropagation()}>
                          <ChequeUpload
                            entity={costReimburse}
                            panel={"cost_reimbursement"}
                            pageId={page_id_click_record}
                            documentType="verify"
                            updateStates={updateCostsReimbursementsState}
                            handleNoCheckShow={handleNoCheckShow}
                          />
                        </td>
                        <td
                          className="td-autosize text-center"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div
                            className={`${costsReimbursementsLocks[index]?.checkID?.cheque_number ? "check-class" : "d-flex justify-content-center"} `}
                          >
                            {!costsReimbursementsLocks[index].checkID &&
                            costsReimbursementsLocks[index].isFinalLocked &&
                            hasNonZeroSettlementAmount(
                              costsReimbursementsLocks[index].isFinalAmount
                            ) ? (
                              <div className="d-flex align-items-center justify-content-center">
                                <div
                                  className="settle-check-request-btn btn"
                                  id="nomargin"
                                  style={{
                                    color: "white",
                                    fontWeight: "600",
                                    background: "#009900",
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (costsReimbursementsLocks[index].isFinalLocked) {
                                      setCurrentCostReimbursement({
                                        ...costReimburse,
                                        final: costsReimbursementsLocks[index].isFinalAmount,
                                      });
                                      setCheckRequestModal(true);
                                    }
                                  }}
                                >
                                  <p className={"font-weight-semibold"}>Request Check</p>
                                </div>
                              </div>
                            ) : (
                              <SettlementCheckDetails
                                entity={costReimburse}
                                check={costsReimbursementsLocks[index].checkID}
                                pageId={page_id_click_record}
                                updateStates={updateCostsReimbursementsState}
                                handleNoCheckShow={handleNoCheckShow}
                              />
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                    {/* {costsReimbursements.length > 0 && ( */}
                    <tr className="cursor-default">
                      <td />
                      <td className="height-25 text-capitalize text-end" colSpan={colSpanValue}>
                        <span className="whitespace-SETTLE primary-clr-25">
                          Remaining to be Reimbursed to{" "}
                          {caseSummary?.for_client?.created_by?.office_name}:{" "}
                        </span>
                        <p
                          className="d-inline-flex align-items-center height-25 monospace-font text-end fw-bold dollar-amount-value"
                          data-value={parseFloat(
                            parseFloat(costFinalAmount || 0.0) -
                              parseFloat(costReimbursementsFinalAmount || 0.0)
                          ).toFixed(2)}
                        >
                          {currencyFormat(
                            parseFloat(costFinalAmount || 0.0) -
                              parseFloat(costReimbursementsFinalAmount || 0.0)
                          )}
                        </p>
                      </td>
                      <td
                        className="s-draft monospace-font text-end dollar-amount-value"
                        data-value={parseFloat(
                          parseFloat(costFinalAmount || 0.0) -
                            parseFloat(costReimbursementsLockValues[0] || 0.0)
                        ).toFixed(2)}
                      >
                        <span style={{ paddingRight: "2px" }}>
                          {currencyFormat(
                            parseFloat(costFinalAmount || 0.0) -
                              parseFloat(costReimbursementsLockValues[0] || 0.0)
                          )}
                        </span>
                      </td>
                      <td
                        className="s-final monospace-font text-end dollar-amount-value"
                        data-value={parseFloat(
                          parseFloat(costFinalAmount || 0.0) -
                            parseFloat(costReimbursementsLockValues[1] || 0.0)
                        ).toFixed(2)}
                      >
                        <span style={{ paddingRight: "2px" }}>
                          {currencyFormat(
                            parseFloat(costFinalAmount || 0.0) -
                              parseFloat(costReimbursementsLockValues[1] || 0.0)
                          )}
                        </span>
                      </td>
                      <td className="s-verify" />
                      <td className="td-autosize" />
                    </tr>
                    {/* )} */}
                  </>
                )}
              </>
            </tbody>
          </table>
        </div>
      </div>
      {showCostModal && (
        <AddCostReimburstmentPopUp
          action={action}
          costReimburse={currentCostReimbursement}
          costReimbursements={costsReimbursements}
          setCurrentCostReimbursement={setCurrentCostReimbursement}
          show={showCostModal}
          handleClose={() => {
            handleCostClose();
            updateCostsReimbursementsState();
          }}
          updateStates={updateCostsReimbursementsState}
          costsReimbursements={costsReimbursements}
          total={costFinalAmount}
          remainingToBeReimburse={
            parseFloat(costFinalAmount || 0.0) - parseFloat(costReimbursementsFinalAmount || 0.0)
          }
        />
      )}
      {showSettlementPopup && (
        <GenericSettlementAddPopup
          show={showSettlementPopup}
          handleClose={() => {
            setShowSettlementPopup(false);
          }}
          _initialLabel={"Firm Cost Reimbursement"}
          {...settlementObjProps}
        />
      )}
      {showErrorModal && (
        <SettlementErrorModal
          show={showErrorModal}
          handleClose={handleErrorClose}
          errorMsg={errorMsg}
          updateStates={updateCostsReimbursementsState}
        />
      )}
      {showNoCheckModal && (
        <SettlementNoCheckModal show={showNoCheckModal} handleClose={handleNoCheckClose} />
      )}
      {checkAlreadyRequested && (
        <CheckAlreadyRequestedModal
          show={checkAlreadyRequested}
          hideModal={handleCheckAlreadyRequestedClose}
        />
      )}
      {showCheckRequestModal && (
        <SettlementCheckRequest
          show={showCheckRequestModal}
          handleClose={handleCheckRequestClose}
          finalAmount={currentCostReimbursement?.final}
          panelLabel={"CostSettlement"}
          panelName={"cost_reimburse"}
          panelEntity={currentCostReimbursement}
          contact_obj={currentCostReimbursement?.payee_contact}
          updateStates={() => {
            updateCostsState();
            updateCostsReimbursementsState();
            clientProceed.updateClientProceedsState();
          }}
        />
      )}
    </>
  );
};

export default SettlementCosts;
